import { SERVICES } from "utils/constants";
import Service from "./Service";
import { useRef } from "react";

const Services = () => {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scrollLeft = () => {
    scrollRef.current?.scrollBy({ left: -200, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollRef.current?.scrollBy({ left: 200, behavior: "smooth" });
  };

  return (
    <div className="relative">
      <button
        className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-gray-200 p-2 rounded-r-md z-10 shadow-md hover:bg-gray-300"
        onClick={scrollLeft}
        aria-label="Scroll left"
      >
        &lt;
      </button>
      <div
        ref={scrollRef}
        className="flex overflow-x-auto space-x-4 py-4 pl-[4%] h-max-[85%] h-[700px]"
      >
        {SERVICES.map((service, index) => (
          <div key={index} className="flex-shrink-0 w-[40%]">
            <Service
              header={service.title}
              body={service.description}
              image={service.imgUrl}
              navigateTo={service.path}
            />
          </div>
        ))}
      </div>
      <button
        className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-gray-200 p-2 rounded-l-md z-10 shadow-md hover:bg-gray-300"
        onClick={scrollRight}
        aria-label="Scroll right"
      >
        &gt;
      </button>
    </div>
  );
};

export default Services;
